export default __webpack_public_path__ + "static/bot-laptop-ee68d7fefdd7a533a074d935240ec826.svg";